import { proposalSlice } from 'v3/data/store/proposal';
import { IFinancing, IFinancingDetails, IProduct } from 'v3/data/store/proposal/types';
import { store } from '..';

export const setProposalFinancingInformations = (financing: IFinancing) => {
  store.dispatch(proposalSlice.actions.setProposalFinancingInformations(financing));
};

export const setProposalProductPrice = (product: IProduct) => {
  store.dispatch(proposalSlice.actions.setProposalProductPrice(product));
};

export const setProposalFinancingDetails = (financingDetails: IFinancingDetails) => {
  store.dispatch(proposalSlice.actions.setProposalFinancingDetails(financingDetails));
};

export const clearProposalInfo = () => {
  store.dispatch(proposalSlice.actions.clearProposalInfo());
};
